var drawerController = () => {
    document.querySelectorAll('.drawer-toggle-bottom').forEach(btn => {
        const drawerSelector = btn.getAttribute('data-drawer');
        const drawer = document.querySelector(drawerSelector);
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            drawer.classList.toggle('drawer-visible');
        });

    });

    document.querySelectorAll('.drawer-close').forEach(btn => {
        const drawer = btn.closest('.drawer');
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            drawer.classList.remove('drawer-visible');
        });
    });

    // side drawer
    document.querySelectorAll('.drawer-toggle').forEach(btn => {
        const drawerSelector = btn.getAttribute('data-drawer');
        const drawer = document.querySelector(drawerSelector);
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            drawer.classList.toggle('drawer-visible');
        });

    });

    // close when clicking in mainContent
    const mainContent = document.querySelector('#mainContent');
    if (mainContent) {
        mainContent.addEventListener('click', () => {
            document.querySelectorAll('.side-drawer').forEach(drawer => {
                drawer.classList.remove('drawer-visible');
            });
        });
    }

    const header = document.querySelector('header');
    if (header) {
        header.addEventListener('click', () => {
            document.querySelectorAll('.side-drawer').forEach(drawer => {
                drawer.classList.remove('drawer-visible');
            });
        });
    }

    // close menu when click on a link
    /*
    document.querySelectorAll('.drawer .menu-category a').forEach(link => {
        link.addEventListener('click', () => {
            setTimeout(() => {
                document.querySelectorAll('.drawer').forEach(drawer => {
                    drawer.classList.remove('drawer-visible');
                });
            }, 1000);
        });
    });*/
};
